module.exports = __webpack_public_path__ + "static/media/access.bebcdd4b.svg";